
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"7","cy":"7.127","rx":"7","ry":"7.127","fill":"#1855D1"}}),_c('path',{attrs:{"d":"M7.352 3.08v3.168L7.184 8.48H6.176l-.168-2.232V3.08h1.344zM6.68 9.416c.272 0 .488.08.648.24.168.152.252.356.252.612s-.084.46-.252.612c-.16.152-.376.228-.648.228-.264 0-.48-.076-.648-.228-.16-.152-.24-.356-.24-.612s.08-.46.24-.612a.901.901 0 01.648-.24z","fill":"#fff"}})])
          )
        }
      }
    